import { userConstants } from './constantData';

export const PROFILES_DATA = {
  home_profiles: {
    page_view: {
      hash: 'p-042.001.000.000.000.000',
      event: 'pages',
      dimensions: [...userConstants],
    },
    select_profile: {
      hash: 'e-042.001.001.000.000.161',
      event: 'interactions',
      dimensions: [...userConstants],
    },
    create_profile: {
      hash: 'e-042.001.001.000.000.157',
      event: 'interactions',
      dimensions: [...userConstants],
    },
    manage_profiles: {
      hash: 'e-042.001.001.000.000.158',
      event: 'interactions',
      dimensions: [...userConstants],
    },
  },
  home_profiles_edit_create: {
    page_view: {
      hash: 'p-042.056.000.000.000.000',
      event: 'pages',
      dimensions: [...userConstants],
    },
    select_edit_profile: {
      hash: 'e-042.056.001.000.000.159',
      event: 'interactions',
      dimensions: [...userConstants],
    },
    create_profile: {
      hash: 'e-042.001.001.000.000.157',
      event: 'interactions',
      dimensions: [...userConstants],
    },
    manage_profiles_back: {
      hash: 'e-042.001.001.000.000.028',
      event: 'interactions',
      dimensions: [...userConstants],
    },
  },
  profiles_create_name: {
    page_view: {
      hash: 'p-042.134.000.000.000.000',
      event: 'pages',
      dimensions: [...userConstants],
    },
    page_view_edit: {
      hash: 'p-042.063.000.000.000.000',
      event: 'pages',
      dimensions: [...userConstants],
    },
    continue_profile_edit: {
      hash: 'e-042.063.001.000.000.154',
      event: 'interactions',
      dimensions: [...userConstants],
    },
    back_profiles: {
      hash: 'e-042.134.001.000.000.028',
      event: 'interactions',
      dimensions: [...userConstants],
    },
    continue_profile: {
      hash: 'e-042.134.001.000.000.101',
      event: 'interactions',
      dimensions: [...userConstants],
    },
  },
  profiles_create: {
    page_view: {
      hash: 'p-042.057.000.000.000.000',
      event: 'pages',
      dimensions: [...userConstants],
    },
    page_view_success: {
      hash: 'p-042.068.000.000.000.000',
      event: 'pages',
      dimensions: [...userConstants],
    },
    page_view_error: {
      hash: 'p-041.023.000.000.000.000',
      event: 'pages',
      dimensions: [
        ...userConstants,
        'v_error_code',
        'v_error_type',
        'v_change_parental_control',
      ],
    },
    ok_error_create_profile: {
      hash: 'e-041.023.001.000.000.154',
      event: 'interactions',
      dimensions: [
        ...userConstants,
        'v_error_code',
        'v_error_type',
        'v_change_parental_control',
      ],
    },
    back_profiles: {
      hash: 'e-042.134.001.000.000.028',
      event: 'interactions',
      dimensions: [...userConstants],
    },
    back_profiles_create: {
      hash: 'e-042.057.001.000.000.028',
      event: 'interactions',
      dimensions: [...userConstants],
    },
    cancel_profiles_create: {
      hash: 'e-042.057.001.000.000.051',
      event: 'interactions',
      dimensions: [...userConstants],
    },
    edit_name_profile: {
      hash: 'e-042.057.001.000.000.245',
      event: 'interactions',
      dimensions: [...userConstants],
    },
    change_allowed_content_profile: {
      hash: 'e-042.063.001.000.000.090',
      event: 'interactions',
      dimensions: [...userConstants],
    },
    select_create_profile: {
      hash: 'e-042.057.001.000.000.157',
      event: 'interactions',
      dimensions: [...userConstants],
    },
  },
  profiles_edit: {
    page_view: {
      hash: 'p-042.063.000.000.000.000',
      event: 'pages',
      dimensions: [...userConstants],
    },
    page_view_success: {
      hash: 'p-042.065.000.000.000.000',
      event: 'pages',
      dimensions: [
        ...userConstants,
        'v_change_parental_control',
      ],
    },
    back_profiles: {
      hash: 'e-042.063.001.000.000.028',
      event: 'interactions',
      dimensions: [...userConstants],
    },
    edit_name_profile: {
      hash: 'e-042.063.001.000.000.245',
      event: 'interactions',
      dimensions: [...userConstants],
    },
    change_allowed_content_profile: {
      hash: 'e-042.063.001.000.000.090',
      event: 'interactions',
      dimensions: [...userConstants],
    },
    confirm_edit_profile: {
      hash: 'e-042.063.001.000.000.154',
      event: 'interactions',
      dimensions: [...userConstants],
    },
    delete_edit_profile: {
      hash: 'e-042.063.001.000.000.162',
      event: 'interactions',
      dimensions: [...userConstants],
    },
  },
  profiles_delete: {
    page_view: {
      hash: 'p-042.066.000.000.000.000',
      event: 'pages',
      dimensions: [...userConstants],
    },
    page_view_success: {
      hash: 'p-042.067.000.000.000.000',
      event: 'pages',
      dimensions: [...userConstants],
    },
    back_profiles: {
      hash: 'e-042.066.001.000.000.028',
      event: 'interactions',
      dimensions: [...userConstants],
    },
    confirm_delete_profile: {
      hash: 'e-042.066.001.000.000.162',
      event: 'interactions',
      dimensions: [...userConstants],
    },
    notnow_delete_profile: {
      hash: 'e-042.066.001.000.000.047',
      event: 'interactions',
      dimensions: [...userConstants],
    },
  },
  profiles_onboarding: {
    page_view: {
      hash: 'p-042.059.000.000.000.000',
      event: 'pages',
      dimensions: [...userConstants],
    },
    continue_onboarding: {
      hash: 'e-042.059.001.000.000.101',
      event: 'interactions',
      dimensions: [...userConstants],
    },
    page_view_create_name: {
      hash: 'p-042.060.000.000.000.000',
      event: 'pages',
      dimensions: [...userConstants],
    },
    continue_create_name_onboarding: {
      hash: 'e-042.060.001.000.000.101',
      event: 'interactions',
      dimensions: [...userConstants],
    },
    page_view_create_confirmation_onboarding: {
      hash: 'p-042.133.000.000.000.000',
      event: 'pages',
      dimensions: [...userConstants],
    },
    continue_create_confirmation_onboarding: {
      hash: 'e-042.133.001.000.000.160',
      event: 'interactions',
      dimensions: [...userConstants],
    },
    edit_name_confirmation_onboarding: {
      hash: 'e-042.133.001.000.000.245',
      event: 'interactions',
      dimensions: [...userConstants],
    },
    page_view_create_success_onboarding: {
      hash: 'p-042.062.000.000.000.000',
      event: 'pages',
      dimensions: [...userConstants],
    },
    page_view_error_onboarding: {
      hash: 'p-041.023.000.000.000.000',
      event: 'pages',
      dimensions: [
        ...userConstants,
        'v_change_parental_control',
      ],
    },
    continue_error_onboarding: {
      hash: 'e-041.023.001.000.000.101',
      event: 'interactions',
      dimensions: [...userConstants],
    },
    try_again_error_onboarding: {
      hash: 'e-041.023.001.000.000.117',
      event: 'interactions',
      dimensions: [...userConstants],
    },
  },
};
